import Axios from 'axios'

// Hardcoded label values
import { apiUrlGetBoardOptionLabels } from '../data/residential/get-board-type-option-labels'
import { apiUrlGetBreakerOptionLabels } from '../data/residential/get-breaker-type-option-labels' 

const { CONST } = require('../CONST')

// -----------------------------------
// Defind consts for the api calls
// -----------------------------------
export const apiUrlGetDocument = `${CONST.API_PATH_RESIDENTIAL}/Project/GetDocument`
const apiUrlGetLayoutDiagrams = `${CONST.API_PATH_RESIDENTIAL}/Project/GetLayoutDiagrams`
const apiUrlArchiveDeleteProject = `${CONST.API_PATH_RESIDENTIAL}/Project/Archive`
const apiUrlCopyProject = `${CONST.API_PATH_RESIDENTIAL}/Project/Copy`
const apiUrlActivityCount = `${CONST.API_PATH_RESIDENTIAL}/Project/ActivityCount`
const apiUrlAllProjects = `${CONST.API_PATH_RESIDENTIAL}/Project/AllProjects`
const apiUrlGetProject = `${CONST.API_PATH_RESIDENTIAL}/Project/Get`
const apiUrlGetBoardOptions = `${CONST.API_PATH_RESIDENTIAL}/ReferenceData/GetBoardTypeOptions`
const apiUrlGetBreakerOptions = `${CONST.API_PATH_RESIDENTIAL}/ReferenceData/GetBreakerTypeOptions`
const apiUrlGetContactorsOptions = `${CONST.API_PATH_RESIDENTIAL}/ReferenceData/GetContractors`
const apiUrlGetUserFavouriteBreakers = `${CONST.API_PATH_RESIDENTIAL}/ReferenceData/GetUserFavouriteBreakers`
const apiUrlDeleteBoard = `${CONST.API_PATH_RESIDENTIAL}/Project/DeleteBoard`
const apiUrlCopyBoard = `${CONST.API_PATH_RESIDENTIAL}/Project/CopyBoard`
const apiUrlSaveBoard = `${CONST.API_PATH_RESIDENTIAL}/Project/SaveBoard`
const apiUrlGetBoardMiscParts = `${CONST.API_PATH_RESIDENTIAL}/ReferenceData/GetMiscellaneousParts`
const apiUrlGenerateQuote = `${CONST.API_PATH_RESIDENTIAL}/Project/Quote`
const apiUrlSaveProject = `${CONST.API_PATH_RESIDENTIAL}/Project/SaveProject`
const apiUrlSendOrder = `${CONST.API_PATH_RESIDENTIAL}/Project/PlaceOrder`
const apiUrlApplyPromoCode = `${CONST.API_PATH_RESIDENTIAL}/Project/ApplyPromoCode`
const apiUrlGetBoard = `${CONST.API_PATH_RESIDENTIAL}/Project/GetBoard`
const apiUrlSaveBoardBreakerToolbox = `${CONST.API_PATH_RESIDENTIAL}/Project/SaveToolboxBreaker`
const apiUrlSaveBoardContactorToolbox = `${CONST.API_PATH_RESIDENTIAL}/Project/SaveToolboxContactor`
const apiUrlSaveBoardFittedOptionToolbox = `${CONST.API_PATH_RESIDENTIAL}/Project/SaveToolboxFittedOption`
const apiUrlSaveFavBreaker = `${CONST.API_PATH_RESIDENTIAL}/ReferenceData/SaveFavouriteBreaker`
const apiUrlSaveBreakerToChassis = `${CONST.API_PATH_RESIDENTIAL}/Project/SaveBreaker`
const apiUrlSaveContactorToChassis = `${CONST.API_PATH_RESIDENTIAL}/Project/SaveContractor`
const apiUrlSaveFittedOptionToChassis = `${CONST.API_PATH_RESIDENTIAL}/Project/SaveFittedOption`
// const apiUrlSaveBoardChassisOptions = `${CONST.API_PATH_RESIDENTIAL}/Project/SaveBoardFittedOptions`
const apiUrlSaveBoardMiscParts = `${CONST.API_PATH_RESIDENTIAL}/Project/SaveBoardLooseSupplyItems`
const apiUrlAttachPo = `${CONST.API_PATH_RESIDENTIAL}/Project/AttachPO`
const apiUrlEmailQuote = `${CONST.API_PATH_RESIDENTIAL}/Project/EmailQuote`
const apiUrlGetBusBars = `${CONST.API_PATH_RESIDENTIAL}/Project/GetBusBars`
const apiUrlSaveBusBar = `${CONST.API_PATH_RESIDENTIAL}/Project/SaveBusBar`
const apiURLGetAllParts = `${CONST.API_PATH_RESIDENTIAL}/ReferenceData/Parts`

// -----------------------------------
// Export clean api call functions for internal use
// @NOTE - All the api calls are done as an AJAX call, thus all these functions will return a promise
// -----------------------------------

// Get Documents
export function apiGetDocument(documentID = 0) {
    return processRequest(
        Axios.get(`${apiUrlGetDocument}/${documentID}`),
        'download document'
    )
}

// GetLayoutDiagrams
export function apiGetLayoutDiagrams(projectId = 0) {
    return processRequest(
        Axios.get(`${apiUrlGetLayoutDiagrams}/${projectId}?{}`),
        'retrieve layout diagrams'
    )
}

// Archive or Delete a Project
export function apiArchiveDeleteProject(requestObj) {
    return processRequest(
        Axios.post(apiUrlArchiveDeleteProject, requestObj),
        'retrieve project data'
    )
}

// Copy a whole Project
export function apiCopyProject(requestObj) {
    return processRequest(
        Axios.post(apiUrlCopyProject, requestObj),
        'retrieve project data'
    )
}

// Return the number of projects a user has complete, incomplete or to be approved.
export function apiActivityCount() {
    return processRequest(
        Axios.get(apiUrlActivityCount),
        'retrieve project data'
    )
}

// Return a list of all projects that are complete/incomplete/to-be-approved.
export function apiAllProjects(requestObj) {
    return processRequest(
        Axios.post(apiUrlAllProjects, requestObj),
        'retrieve project data'
    )
}

// Get the project data
export function apiGetProject(projectId = 0) {
    return processRequest(
        Axios.get(`${apiUrlGetProject}/${projectId}?timestamp=${new Date().getTime()}`),
        'retrieve project data',
    )
}

// Get the board data
export function apiGetBoard(projectId, boardId) {
    return processRequest(
        Axios.post(apiUrlGetBoard, {
            "ProjectID": projectId,
            "ProjectBoardID": boardId
        }),
        'get board data'
    )
}

// Get the board misc parts data
export function apiGetBoardMiscParts(boardID) {
    let requestURL = apiUrlGetBoardMiscParts

    if (boardID !== null && boardID !== undefined) {
        requestURL = requestURL + '?boardID=' + boardID
    }

    return processRequest(
        Axios.get(requestURL),
        'retrieve board misc parts data'
    )
}

// Get the board options
export function apiGetBoardOption() {
    return processRequest(
        Axios.get(apiUrlGetBoardOptions),
        'retrieve board options data'
    )
}

export function apiGetBusBars() {
    return processRequest(
        Axios.get(apiUrlGetBusBars),
        'retrieve busbars data'
    )
}

export function apiSaveBusBar(projectId, boardId, itemID = 0, busBarItemID, row, extraPoles, startPosition, busbarLength, isDeleted = false) {
    return processRequest(
        Axios.post(apiUrlSaveBusBar, {
            "ItemID": itemID,
            "ProjectID": projectId,
            "ProjectBoardID": boardId,
            "BusBarItemID": busBarItemID,
            "Row": row,
            "ExtraPoles": extraPoles,
            "StartPosition": startPosition,
            "BusBarLength": busbarLength,
            "IsDeleted": isDeleted
        }),
        'save busbar'
    )
}

export function apiGetAllParts() {
    return processRequest(
        Axios.get(apiURLGetAllParts),
        'retrieve all parts data'
    )
}

// Get the board option labels - this returns a promise like other api calls even tho it is just
// loading hardcoded values - we'd like this to change in the future to have hte values come from server
export function apiGetBoardOptionLabels() {
    return new Promise(resolve => resolve(apiUrlGetBoardOptionLabels.Data) )
}

// Get the Breaker options
export function apiGetBreakerOptions() {
    return processRequest(
        Axios.get(apiUrlGetBreakerOptions),
        'retrieve breaker options data',
    )
}

// Get the Contactors options
export function apiGetContactorsOptions() {
    return processRequest(
        Axios.get(apiUrlGetContactorsOptions),
        'retrieve contactors options data',
    )
}

// Get user favourite breakers
export function apiGetUserFavouriteBreakers() {
    return processRequest(
        Axios.get(apiUrlGetUserFavouriteBreakers),
        'retrieve user favourite breakers',
    )
}

// Get the breaker option labels - this returns a promise like other api calls even tho it is just
// loading hardcoded values - we'd like this to change in the future to have hte values come from server
export function apiGetBreakerOptionLabels() {
    return new Promise(resolve => resolve(apiUrlGetBreakerOptionLabels.Data) )
}

export function apiDeleteBoard(projectId, boardId) {
    return processRequest(
        Axios.post(apiUrlDeleteBoard, {
            "ProjectID": projectId,
            "BoardID": boardId
        }),
        'delete the board'
    )
}

export function apiSaveBreakerToChassis(projectId, boardId, boardBreakerId = 0, breakerTypeId, rowIndex, poleIndex, isDeleted = false, notes = '', topPowerTag = false, bottomPowerTag = false) {
    return processRequest(
        Axios.post(apiUrlSaveBreakerToChassis, {
            "ItemID": boardBreakerId, // Will be specified if updating the breaker
            "BreakerTypeItemID": breakerTypeId,
            "ProjectBoardID": boardId,
            "ProjectID": projectId,
            "RowIndex": rowIndex,
            "PoleIndex": poleIndex,
            "BreakerCircuitLabel": notes,
            "IsDeleted": isDeleted,
            "TopPowerTag": topPowerTag,
            "BottomPowerTag": bottomPowerTag
        }),
        'save the chassis'
    )
}

export function apiSaveContactorToChassis(projectId, boardId, boardContactorId = 0, contactorId, rowIndex, poleIndex, isDeleted = false, notes = '') {
    return processRequest(
        Axios.post(apiUrlSaveContactorToChassis, {
            "ItemID": boardContactorId, // Will be specified if updating the device
            "ContractorItemID": contactorId,
            "ProjectBoardID": boardId,
            "ProjectID": projectId,
            "RowIndex": rowIndex,
            "PoleIndex": poleIndex,
            "BreakerCircuitLabel": notes,
            "IsDeleted": isDeleted
        }),
        'save contactor to the chassis'
    )
}

export function apiSaveFittedOptionToChassis(projectId, boardId, boardFittedOptionId = 0, contactorId, rowIndex, poleIndex, isDeleted = false, notes = '') {
    return processRequest(
        Axios.post(apiUrlSaveFittedOptionToChassis, {
            "ItemID": boardFittedOptionId, // Will be specified if updating the device
            "FittedOptionItemID": contactorId,
            "ProjectBoardID": boardId,
            "ProjectID": projectId,
            "RowIndex": rowIndex,
            "PoleIndex": poleIndex,
            "BreakerCircuitLabel": notes,
            "IsDeleted": isDeleted
        }),
        'save fitted option to the chassis'
    )
}

// export function apiSaveBoardChassisOptions(projectId, boardId, selectedOptionIds) {
//     return processRequest(
//         Axios.post(apiUrlSaveBoardChassisOptions, {
//             "ProjectID": projectId,
//             "BoardID": boardId,
//             "ProjectBoardFittedOptionCollection": selectedOptionIds
//         }),
//         'add fitted options the chassis'
//     )
// }

export function apiSaveBoardMiscParts(projectId, boardId, selectedPartIds) {
    return processRequest(
        Axios.post(apiUrlSaveBoardMiscParts, {
            "ProjectID": projectId,
            "BoardID": boardId,
            "ProjectBoardLooseSupplyItemCollection": selectedPartIds
        }),
        'add misc parts the chassis'
    )
}

export function apiCopyBoard(projectId, boardId) {
    return processRequest(
        Axios.post(apiUrlCopyBoard, {
            "ProjectID": projectId,
            "BoardID": boardId
        }),
        'copy the board'
    )
}

export function apiSaveBoard(boardData) {
    return processRequest(
        Axios.post(apiUrlSaveBoard, boardData),
        'save the board'
    )
}

export function apiSaveBoardBreakerToolbox(projectId, boardId, breakerTypeId, toolboxBreakerId = 0, isDeleted = false) {
    return processRequest(
        Axios.post(apiUrlSaveBoardBreakerToolbox, {
            "ItemID": toolboxBreakerId,
            "ProjectBoardID": boardId,
            "ProjectID": projectId,
            "BreakerTypeItemID": breakerTypeId,
            "IsDeleted": isDeleted
        }),
        'saving breaker to the board toolbox'
    )
}

export function apiSaveBoardContactorToolbox(projectId, boardId, contactorID, toolboxContactorId = 0, isDeleted = false) {
    return processRequest(
        Axios.post(apiUrlSaveBoardContactorToolbox, {
            "ItemID": toolboxContactorId,
            "ProjectBoardID": boardId,
            "ProjectID": projectId,
            "ContactorItemID": contactorID,
            "IsDeleted": isDeleted
        }),
        'saving contactor to the board toolbox'
    )
}

export function apiSaveBoardFittedOptionToolbox(projectId, boardId, fittedOptionID, toolboxFittedOptionId = 0, isDeleted = false) {
    return processRequest(
        Axios.post(apiUrlSaveBoardFittedOptionToolbox, {
            "ItemID": toolboxFittedOptionId,
            "ProjectBoardID": boardId,
            "ProjectID": projectId,
            "FittedOptionItemID": fittedOptionID,
            "IsDeleted": isDeleted
        }),
        'saving fitted option to the board toolbox'
    )
}

export function apiSaveFavBreaker(userId, breakerTypeId, favBreakerId = 0, isDeleted = false) {
    return processRequest(
        Axios.post(apiUrlSaveFavBreaker, {
            "ItemID": favBreakerId,
            "UserID": userId,
            "BreakerTypeItemID": breakerTypeId,
            "IsDeleted": isDeleted
        }),
        'saving favourite breaker'
    )
}

export function apiSetProjectTitle(updatedProject) {
    return processRequest(
        Axios.post(apiUrlSaveProject, updatedProject),
        'save project'
    )
}

export function apiGenerateQuote(projectId, wholesalerBranchID = -1,
    companyName = '', custName = '', custAddress = '',
    custPhone = '', custEmail = '', custQuoteRef = '', custMarkup = 125, promoCode = '') {
    const quoteData = companyName ? {
        "ProjectID": projectId,
        "WholesalerBranchID": wholesalerBranchID,
        "QuoteCompanyName": companyName,
        "QuoteCustomerName": custName,
        "QuoteCustomerAddress": custAddress,
        "QuoteCustomerPhone": custPhone,
        "QuoteCustomerEmail": custEmail,
        "QuoteCustomerQuoteRef": custQuoteRef,
        "QuoteCustomerMarkupPercent": custMarkup,
        "PromoCode": promoCode
    } : {
        "ProjectID": projectId,
        "WholesalerBranchID": wholesalerBranchID
    }
    return processRequest(
        Axios.post(apiUrlGenerateQuote, quoteData),
        'generate the quote'
    )
}

export function apiSave(saveProjectRequestObj) {
    return processRequest(
        Axios.post(apiUrlSaveProject, saveProjectRequestObj),
        'save the quote'
    )
}

export function apiSendOrder(projectId) {
    return processRequest( Axios.post(apiUrlSendOrder, { "ProjectID": projectId }), 'place the order' )
}

export function apiApplyPromoCode(applyPromoCodeRequestObj) {
    return processRequest(
        Axios.post(apiUrlApplyPromoCode, applyPromoCodeRequestObj),
        'apply the promotional code'
    )
}

export function apiAttachPo(projectId, quoteCents, discountedQuoteCents, file64String) {
    return processRequest(
        Axios.post(apiUrlAttachPo, {
            "ProjectID": projectId,
            "QuoteCentsIncGST": quoteCents,
            "QuoteDiscountedCentsIncGST": discountedQuoteCents,
            "POFileBast64String": file64String
        }),
        'attach purchase order file'
    )
}

export function apiEmailQuote(projectId, email = false, WholesalerIds) {
    let requestObject = {
        "ProjectID": projectId,
        "WholesalerManagedQuoteSendEmailToCustomer": email
    }

    if (WholesalerIds !== undefined) {
        requestObject.WholesalerIds = WholesalerIds
    }

    return processRequest(
        Axios.post(apiUrlEmailQuote, requestObject),
        'email quote'
    )
}

function processRequest(promiseRequest, actionName, dataName = 'Data') {
    return new Promise((resolve, reject) => {
        promiseRequest
            .then(response => {
                if (response.data.Success) {
                    // On successful response, resolve the promise
                    if (!response || !response.data || !response.data[dataName]) {
                        return resolve()
                    }
                    return resolve(response.data[dataName])
                }
                const errorMessage = response.data.Error ? response.data.Error : response.data.Message
                return reject(new Error(`Failed to ${actionName}: ${errorMessage}`))
            })
            // On server error, we reject the promise with an error message
            .catch((error) => {
                if (error.response.status === 401) {
                    // In this case, remove token from localstorage and redirect back to the login page
                    localStorage.removeItem('token')
                    window.location.href = CONST.PAGES.HOME
                } else {
                    return reject(new Error(`Failed to ${actionName}: ${error}`))
                }
            })
    })
}

export const apiCallsResidential = {
    'apiGetDocument': apiGetDocument,
    'apiGetLayoutDiagrams': apiGetLayoutDiagrams,
    'apiArchiveDeleteProject': apiArchiveDeleteProject,
    'apiCopyProject': apiCopyProject,
    'apiActivityCount': apiActivityCount,
    'apiAllProjects': apiAllProjects,
    'apiGetProject': apiGetProject,
    'apiGetBoard': apiGetBoard,
    'apiGetBoardMiscParts': apiGetBoardMiscParts,
    'apiGetBoardOption': apiGetBoardOption,
    'apiGetBoardOptionLabels': apiGetBoardOptionLabels,
    'apiGetBreakerOptions': apiGetBreakerOptions,
    'apiGetContactorsOptions': apiGetContactorsOptions,
    'apiGetUserFavouriteBreakers': apiGetUserFavouriteBreakers,
    'apiGetBreakerOptionLabels': apiGetBreakerOptionLabels,
    'apiDeleteBoard': apiDeleteBoard,
    'apiSaveBreakerToChassis': apiSaveBreakerToChassis,
    'apiSaveContactorToChassis': apiSaveContactorToChassis,
    'apiSaveFittedOptionToChassis': apiSaveFittedOptionToChassis,
    // 'apiSaveBoardChassisOptions': apiSaveBoardChassisOptions,
    // 'apiSaveBoardMiscParts': apiSaveBoardMiscParts,
    'apiCopyBoard': apiCopyBoard,
    'apiSaveBoard': apiSaveBoard,
    'apiSaveBoardBreakerToolbox': apiSaveBoardBreakerToolbox,
    'apiSaveBoardContactorToolbox': apiSaveBoardContactorToolbox,
    'apiSaveBoardFittedOptionToolbox': apiSaveBoardFittedOptionToolbox,
    'apiSaveFavBreaker': apiSaveFavBreaker,
    'apiSetProjectTitle': apiSetProjectTitle,
    'apiGetBusBars': apiGetBusBars,
    'apiSaveBusBar': apiSaveBusBar,
    'apiGenerateQuote': apiGenerateQuote,
    'apiSave': apiSave,
    'apiSendOrder': apiSendOrder,
    'apiApplyPromoCode': apiApplyPromoCode,
    'apiAttachPo': apiAttachPo,
    'apiEmailQuote': apiEmailQuote,
    'apiGetAllParts': apiGetAllParts
} 